import { equals } from 'ramda';
import { IconType } from '../Icon/Utils/IconDefinitions';

export interface ISelectChoice<T> {
  header: string;
  listHeader?: string;
  subHeader?: string;
  value: T;
  disabled?: boolean;
  disabledReason?: string;
  section?: string;
  testId?: string;
  icon?: IconType;
}

export const getSelectChoiceNameFromValue = <
  T extends { toString: () => string }
>(
  value: T | undefined,
  items: Array<ISelectChoice<T>>
): string => {
  if (value === undefined) {
    return '';
  }

  const result = items.find(val => equals(val.value, value));
  return result ? result.header : value.toString();
};
